import { makeStyles } from '@material-ui/core/styles'

const styles = makeStyles(theme => ({
  button: {
    borderRadius: 0,
    padding: '8px 24px',
    height: 42
  },
  disabledButton: {
    background: '#F1F1F1',
    color: ['#A7A4A4', '!important'],
    opacity: 1
  }
}))

export default styles



// WEBPACK FOOTER //
// ./src/dialogs/Item/Action/styles.js